<template>
  <div>
    <el-row style="margin-top: 20px">
      <el-col style="display: flex;justify-content: center;" >
        <el-form
          :model="foodForm"
          :rules="foodrules"
          ref="foodForm"
          label-width="110px"
          class="form food_form"
          style=" width: 900px"
        >
          <el-form-item label="上传">
            <el-upload
              name="filename"
              class="avatar-uploader"
              action="http://pt.zhzymedia.cn/api/fileUpload/WorldUpload/v1"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              accept=".docx"
              multiple
              drag
              :limit="1"
              :on-exceed="handleExceed"
              :on-success="uploadImgSuccess"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或
                <em>点击上传</em>【仅支持docx格式】
              </div>
              <div slot="tip" class="el-upload__tip" style="color:red">由于word格式兼容性问题，不保证其格式、内容以及图片展现一致，建议使用来源发布，如使用word文档上传，清仔细检查内容是否有误。</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="标题" required>
            <el-input
              v-model="title"
              
              placeholder="标题建议25字左右，长了部分媒体可能会修改，不要出现特殊字符（系统默认最长标题45字）"
            ></el-input>
          </el-form-item>
          <el-form-item label="转载链接">
            <el-input v-model="link"></el-input>
            <p style="color: #fd5454">填写转发来源或素材</p>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="remark" placeholder="填写您的投放备注信息要求，如：出稿时间要求、排版、格式等（与媒体备注冲突的默认无效！"></el-input>
          </el-form-item>
          <el-form-item label="用户备注">
            <el-input v-model="personalReamrk" placeholder="备注文章发布所属客户、项目或者执行人，仅用户个人可见。不对资源主以及平台方展现。"></el-input>
          </el-form-item>
          <!-- <el-form-item label="会员备注" prop="description">
            <el-input v-model="foodForm.description"></el-input>
          </el-form-item>-->
          <el-form-item label="内容" prop="description">
            <div id="editor8" class="editor" style="z-index: 900"></div>
          </el-form-item>
          <!--  -->

          <el-form-item>
            <!-- <el-button type="primary">预览文章</el-button> -->
            <el-button
              style="background-color: #fd5353; border-color: #fd5353"
              type="primary"
              @click="next"
            >确认下一步</el-button>
            <el-button
              type="primary"
              v-show="formArticle!=''&&formArticle!='<p><br></p>'"
              @click="look"
            >预览效果</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import myAxios from "../../myAxios";
import axios from "axios";
import HeadTop from "../../components/HeadTop";
import E from "wangeditor";
import { Promise } from "q";
export default {
  name: "editor",
  mounted() {
    var editor = new E("#editor8");
    editor.customConfig.onchange = html => {
      this.formArticle = html;
    };
    // editor.customConfig.uploadImgServer = "http://rw.qqcjw.com/api/FileUpload/UploadBase64"; //上传URL
    editor.customConfig.uploadImgMaxSize = 3 * 1024 * 1024;
    editor.customConfig.uploadImgMaxLength = 5;
    editor.customConfig.uploadFileName = "myFileName";
    editor.customConfig.customUploadImg = function(files, insert) {
      console.log(files);
      let data = new FormData();
      data.append("filename", files[0]);
      let imgUrl = "";
      axios
        .post("http://pt.zhzymedia.cn/api/fileUpload/FileNameUpload/v1", data)
        .then(res => {
          imgUrl = res.data.data;
        })
        .then(() => {
          insert(imgUrl);
        });
    };
    editor.create();
    let content = localStorage.getItem("content") || "";
    if (content != "") {
      editor.txt.append(content);
      this.formArticle=content
      localStorage.removeItem("content");
    }
  },
  data() {
    return {
            personalReamrk:"",
      filename: "",
      file: "http",
      title: "",
      link: "",
      remark: "",
      personalRemark: "",
      formArticle: "",
      url: localStorage.getItem("url"),
      content: "",
      restaurant_id: 1,
      categoryForm: {
        categoryList: [],
        categorySelect: "",
        name: "",
        description: ""
      },
      foodForm: {
        name: "",
        description: "",
        image_path: "",
        activity: "",
        attributes: [],
        specs: [
          {
            specs: "默认",
            packing_fee: 0,
            price: 20
          }
        ]
      },
      foodrules: {
        name: [{ required: true, message: "请输入食品名称", trigger: "blur" }]
      },
      attributes: [
        {
          value: "新",
          label: "新品"
        },
        {
          value: "招牌",
          label: "招牌"
        }
      ],
      showAddCategory: false,
      foodSpecs: "one",
      dialogFormVisible: false,
      specsForm: {
        specs: "",
        packing_fee: 0,
        price: 20
      },
      specsFormrules: {
        specs: [{ required: true, message: "请输入规格", trigger: "blur" }]
      }
    };
  },
  components: {
    HeadTop
  },
  created() {
    let title = localStorage.getItem("title") || "";
    let link = localStorage.getItem("link") || "";
    let remark = localStorage.getItem("remark") || "";
    let personalReamrk = localStorage.getItem("personalReamrk") || "";
    if (title !== "") {
      this.title = title;
      localStorage.removeItem("title");
    }
    if (remark !== "") {
      this.remark = remark;
      localStorage.removeItem("remark");
    }
        if (personalReamrk !== "") {
      this.personalReamrk = personalReamrk;
      localStorage.removeItem("personalReamrk");
    }
    if (link !== "") {
      this.link = link;
      localStorage.removeItem("link");
    }
  },
  computed: {
    selectValue: function() {
      return (
        this.categoryForm.categoryList[this.categoryForm.categorySelect] || {}
      );
    }
  },
  methods: {
    toPrint(data) {
      var editor = new E("#editor");
      editor.customConfig.onchange = html => {
        this.formArticle = html;
      };
      editor.customConfig.uploadImgMaxSize = 3 * 1024 * 1024;
      editor.customConfig.uploadImgMaxLength = 5;
      editor.customConfig.uploadFileName = "myFileName";
      editor.customConfig.customUploadImg = function(files, insert) {
        console.log(files);
        let data = new FormData();
        data.append("filename", files[0]);
        let imgUrl = "";
        axios
          .post("http://pt.zhzymedia.cn/api/fileUpload/FileNameUpload/v1", data)
          .then(res => {
            imgUrl = res.data.data;
          })
          .then(() => {
            insert(imgUrl);
          });
      };
      editor.create();
      editor.txt.html(data);
      this.formArticle = data;
    },
    // 下一步
    next() {
          if(this.title.length>45){
          this.$message("标题请不要超过45个字", "提示", {
          confirmButtonText: "确定"
        });
        return
      }  if (this.title == "") {
        this.$message("请填写文章标题", "提示", {
          confirmButtonText: "确定"
        });
      } else {
        if (this.link == "" && this.formArticle == "" && this.filename == "") {
          this.$message("转载链接、上传文件、内容必须填写其中一项", "提示", {
            confirmButtonText: "确定"
          });
        } else {
          localStorage.setItem("title", this.title);
          localStorage.setItem("link", this.link);
          localStorage.setItem("content", this.formArticle);
          localStorage.setItem("remark", this.remark);
          localStorage.setItem("personalReamrk", this.personalReamrk);
          this.$router.push({ path: "/chooersmedia",query:{num:3}});
        }
      }
    },
    look() {
          if(this.title.length>45){
          this.$message("标题请不要超过45个字", "提示", {
          confirmButtonText: "确定"
        });
        return
      }  if (this.title == "") {
        this.$message("请填写文章标题", "提示", {
          confirmButtonText: "确定"
        });
      } else {
        if (this.formArticle == "") {
          this.$message("必须填写内容或上传docx才能使用预览功能", "提示", {
            confirmButtonText: "确定"
          });
        } else {
          localStorage.setItem("content", this.formArticle);
          console.log(this.formArticle);
          let newpage = this.$router.resolve({
            name: "preview"
          });
          window.open(newpage.href, "_blank");
        }
      }
    },
    catchData(value) {
      this.content = value; //在这里接受子组件传过来的参数，赋值给data里的参数
    },
    addCategoryFun() {
      this.showAddCategory = !this.showAddCategory;
    },
    uploadImgSuccess(response, file, fileList) {
      if (response.code == 1) {
        this.$alert(response.message, "提示", {
          confirmButtonText: "确定"
        });
        return;
      }
      this.toPrint(response.data);
      this.filename = file.name;
      // localStorage.setItem("file", response.data);
      this.$notify({
        title: "成功",
        message: "上传成功",
        type: "success"
      });
    },
    //
    handleRemove(file, fileList) {
      console.log("file, fileList");
      localStorage.removeItem("file");
      this.filename = "";
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`最多可选择上传 1 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    }
  }
};
</script>

<style lang="less">
@import "../../style/mixin";
.form {
  min-width: 400px;
  margin-bottom: 30px;
  &:hover {
    box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6),
      0 2px 4px 0 rgba(232, 237, 250, 0.5);
    border-radius: 6px;
    transition: all 400ms;
  }
}
.food_form {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}
.form_header {
  text-align: center;
  margin-bottom: 10px;
}
.category_select {
  border: 1px solid #eaeefb;
  padding: 10px 30px 10px 10px;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}
.add_category_row {
  height: 0;
  overflow: hidden;
  transition: all 400ms;
  background: #f9fafc;
}
.showEdit {
  height: 185px;
}
.add_category {
  background: #f9fafc;
  padding: 10px 30px 0px 10px;
  border: 1px solid #eaeefb;
  border-top: none;
}
.add_category_button {
  text-align: center;
  line-height: 40px;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  border: 1px solid #eaeefb;
  border-top: none;
  transition: all 400ms;
  &:hover {
    background: #f9fafc;
    span,
    .edit_icon {
      color: #20a0ff;
    }
  }
  span {
    .sc(14px, #999);
    transition: all 400ms;
  }
  .edit_icon {
    color: #ccc;
    transition: all 400ms;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #20a0ff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
.cell {
  text-align: center;
}
</style>
